export const listaCamisetas = [

  {
    _id: 11,
    label: '# Camisetas',
    disabled: true
  },
  {
    _id: 1,
    value: 'P - Ombro: 45, Largura: 50, Altura: 66, Manga: 21',
    label: 'P - Ombro: 45, Largura: 50, Altura: 66, Manga: 21'
  },
  {
    _id: 2,
    value: 'M - Ombro: 49, Largura: 53, Altura: 71, Manga: 21',
    label: 'M - Ombro: 49, Largura: 53, Altura: 71, Manga: 21'
  },

  {
    _id: 3,
    value: 'G - Ombro: 50, Largura: 55, Altura: 72, Manga: 23',
    label: 'G - Ombro: 50, Largura: 55, Altura: 72, Manga: 23'
  },
  {
    _id: 4,
    value: 'GG - Ombro: 51, Largura: 60, Altura: 77, Manga: 26',
    label: 'GG - Ombro: 51, Largura: 60, Altura: 77, Manga: 26'
  },
  {
    _id: 5,
    value: 'EXG - Ombro: 53, Largura: 64, Altura: 80, Manga: 27',
    label: 'EXG - Ombro: 53, Largura: 64, Altura: 80, Manga: 27'
  },
  {
    _id: 66,
    label: "# Bata Gestante",
    disabled: true,

  },
  {
    _id: 6,
    value: 'P - Bata Gestante',
    label: 'P - Largura: 18, Altura: 20'
  },
  {
    _id: 7,
    value: 'M - Bata Gestante',
    label: 'M - Largura: 19, Altura: 22'
  },

  {
    _id: 8,
    value: 'G - Bata Gestante',
    label: 'G - Largura: 20, Altura: 23'
  },
  {
    _id: 9,
    value: 'GG - Bata Gestante',
    label: 'GG - Largura: 21, Altura: 23'
  }
];

export const listaAgasalhos = [
  {
    _id: 1,
    value: 'P - Largura: 54, Altura: 61, Manga: 57',
    label: 'P - Largura: 54, Altura: 61, Manga: 57'
  },
  {
    _id: 2,
    value: 'M - Largura: 55, Altura: 65, Manga: 59',
    label: 'M - Largura: 55, Altura: 65, Manga: 59'
  },

  {
    _id: 3,
    value: 'G - Largura: 60, Altura: 69, Manga: 60',
    label: 'G - Largura: 60, Altura: 69, Manga: 60'
  },
  {
    _id: 4,
    value: 'GG - Largura: 62, Altura: 72, Manga: 63',
    label: 'GG - Largura: 62, Altura: 72, Manga: 63'
  },
  {
    _id: 5,
    value: 'EXG - Largura: 65, Altura: 75, Manga: 66',
    label: 'EXG - Largura: 65, Altura: 75, Manga: 66'
  }
];

export const OPTIONS_UNIFORMS = [
  {
    _id: 1,
    item: 'Camisetas',
    combo: [
      {
        _id: 2,
        value: 'P - Bata Gestante',
        label: 'P - Bata Gestante: Ombro: 45, Largura: 50'
      },
      {
        _id: 1,
        value: 'M - Bata Gestante',
        label: 'M - Bata Gestante: Ombro: 49, Largura: 53'
      },

      {
        _id: 3,
        value: 'G - Bata Gestante',
        label: 'G - Bata Gestante: Ombro: 50, Largura: 55'
      },
      {
        _id: 4,
        value: 'P - Camiseta',
        label: 'P - Camiseta: Ombro: 45, Largura: 50, Altura: 66, Manga: 21'
      },
      {
        _id: 5,
        value: 'M - Camiseta',
        label: 'M - Camiseta: Ombro: 49, Largura: 53, Altura: 71, Manga: 21'
      },
      {
        _id: 6,
        value: 'G - Camiseta',
        label: 'G - Camiseta: Ombro: 50, Largura: 55, Altura: 72, Manga: 23'
      },
      {
        _id: 7,
        value: 'GG - Camiseta',
        label: 'GG - Camiseta: Ombro: 51, Largura: 60, Altura: 77, Manga: 26'
      },
      {
        _id: 8,
        value: 'ExG - Camiseta',
        label: 'ExG - Camiseta: Ombro: 53, Largura: 64, Altura: 80, Manga: 27'
      }
    ]
  },
  {
    _id: 2,
    item: 'Agasalho',
    combo: [
      {
        _id: 1,
        value: 'P - Bata Gestante',
        label: 'P - Bata Gestante: Ombro: 45, Largura: 50'
      },
      {
        _id: 2,
        value: 'M - Bata Gestante',
        label: 'M - Bata Gestante: Ombro: 49, Largura: 53'
      },

      {
        _id: 3,
        value: 'G - Bata Gestante',
        label: 'G - Bata Gestante: Ombro: 50, Largura: 55'
      },
      {
        _id: 4,
        value: 'P - Camiseta',
        label: 'P - Camiseta: Ombro: 45, Largura: 50, Altura: 66, Manga: 21'
      },
      {
        _id: 5,
        value: 'M - Camiseta',
        label: 'M - Camiseta: Ombro: 49, Largura: 53, Altura: 71, Manga: 21'
      },
      {
        _id: 6,
        value: 'G - Camiseta',
        label: 'G - Camiseta: Ombro: 50, Largura: 55, Altura: 72, Manga: 23'
      },
      {
        _id: 7,
        value: 'GG - Camiseta',
        label: 'GG - Camiseta: Ombro: 51, Largura: 60, Altura: 77, Manga: 26'
      },
      {
        _id: 8,
        value: 'ExG - Camiseta',
        label: 'ExG - Camiseta: Ombro: 53, Largura: 64, Altura: 80, Manga: 27'
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/redux/data/fluxoUniformesTrade.js